import { render, staticRenderFns } from "./LaporanV2.vue?vue&type=template&id=1b2306e7&scoped=true&lang=html&"
import script from "./LaporanV2.vue?vue&type=script&lang=js&"
export * from "./LaporanV2.vue?vue&type=script&lang=js&"
import style0 from "./LaporanV2.vue?vue&type=style&index=0&id=1b2306e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2306e7",
  null
  
)

export default component.exports